import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{class:_vm.$style.jobbookingCreateSubmitBtn,attrs:{"type":"button","rounded":"","depressed":"","x-large":"","disabled":_vm.loading || _vm.disabled},on:{"click":_vm.handleClick}},[_c('span',{class:_vm.$style.text},[_vm._v("Clone the job")]),_c('span',{class:_vm.$style.iconWrapper},[(_vm.loading)?_c(VIcon,{class:_vm.$style.icon + ' mdi-spin'},[_vm._v("mdi-loading")]):_c(VIcon,{class:_vm.$style.icon},[_vm._v("mdi-content-duplicate")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }